var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 183,
    fill: "none",
    viewBox: "0 0 184 183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M69.839 2.504c-17.088 4.232-30.8 12.2-43.505 25.275-9.025 9.29-12.745 14.625-17.975 25.787-13.031 27.807-10.707 60.727 6.14 86.953 12.747 19.843 31.585 33.46 54.949 39.719 11.886 3.184 31.849 3.237 43.732.117 20.168-5.296 44.004-20.725 50.274-32.543 2.278-4.295 2.304-4.574.66-7.084-3.106-4.739-6.702-3.648-15.479 4.694-12.254 11.646-23.56 18.6-36.187 22.258-5.056 1.465-9.721 1.879-21 1.863-13.605-.019-15.087-.217-24-3.2-5.225-1.748-12.35-4.869-15.832-6.935C7.39 133.169-.556 72.353 35.493 36.011 56.148 15.19 88.076 7.265 115.448 16.17c6.234 2.028 19.87 9.206 24.898 13.108l2.399 1.86-12.274 12.415c-13.272 13.425-14.607 16.053-10.037 19.754 2.038 1.65 4.701 1.81 30.17 1.81h27.935l2.454-2.455 2.455-2.454V32.161c0-26.712-.095-28.14-2-30.045-4.066-4.066-6.73-2.808-18 8.5-5.755 5.775-10.973 10.5-11.595 10.5-.621 0-2.879-1.395-5.017-3.1-7.061-5.63-25.055-13.7-35.388-15.872-13.26-2.787-29.471-2.646-41.61.36Zm84.609 35.112-14.474 14.5h30.474v-14.5c0-7.975-.343-14.5-.763-14.5s-7.276 6.525-15.237 14.5Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.ae5195231f5cb2ac6f9be931920e6f14.svg";
export { ForwardRef as ReactComponent };